function confirm_response(popup_contents) {
    $('#popup-confirm .popup h1').text(popup_contents.title);
    $('#popup-confirm .popup .message').text(popup_contents.message);

    // add the class for the OK button and set the data-id
    $('#popup-confirm .btn-popup-confirm-ok').addClass(popup_contents.ok_btn_class);
    $('#popup-confirm .btn-popup-confirm-ok').attr('data-id', popup_contents.elem.data('id'));
}

export {confirm_response}